import { ImageWithFocalPoint as ImageWithFocalPointProps } from '@silvertours/common-landingpages-view';
import Image from 'next/legacy/image';

export const ImageWithFocalPoint = ({
  className,
  src,
  alt,
  width,
  height,
  focalPoint,
}: ImageWithFocalPointProps & { className?: string }) => {
  const xPercentage =
    focalPoint && width ? (focalPoint.x * 100) / width : undefined;
  const yPercentage =
    focalPoint && height ? (focalPoint.y * 100) / height : undefined;
  return (
    <Image
      className={className}
      src={src}
      alt={alt}
      height={height}
      width={width}
      layout="fill"
      objectFit="cover"
      objectPosition={
        xPercentage && yPercentage ? `${xPercentage}% ${yPercentage}%` : ''
      }
    />
  );
};
